// extracted by mini-css-extract-plugin
export default {"pageBody":"page-body_pageBody__ZiR6v"};